export default __webpack_public_path__ + "static/media/tom.72805a74.webp";